import Vue from 'vue'

const token = 'padVisa'

let visa = null
try {
    visa = Vue.prototype.$storage.get(token) || null
} catch (e) {
    visa = null
}

export default {
    namespaced: true,

    state: {
        visa: visa
    },

    getters: {
        visa: state => state.visa
    },

    mutations: {
        visa(state, data) {
            state.visa = data.visa
            Vue.prototype.$storage.set(token, data.visa)
        }
    }
}
